import styled from 'styled-components';

export const DialogBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
`;

export const FooterChips = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin: 0 auto;
`;
